var map = {
	"./1.png": "709d",
	"./2.png": "7652",
	"./3.png": "febc",
	"./4.png": "90b9",
	"./5.png": "f008",
	"./6.png": "e607",
	"./7.png": "618c",
	"./8.png": "7f20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83a3";